"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "search-input flex flex-row items-center gap-1 h-full border border-gray focus-within:outline-none focus-within:ring-4 focus-within:ring-blue focus-within:ring-opacity-50 rounded-md transition-all duration-300" };
const _hoisted_2 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "block w-10 text-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-search text-lg text-gray-dark" })
], -1);
const _hoisted_3 = {
    key: 0,
    class: "tag-list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "tag-text" };
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-close" }, null, -1);
const _hoisted_7 = {
    key: 1,
    class: "search-dropdown"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
    key: 0,
    class: "ellipsis"
};
const debounce_1 = __importDefault(require("lodash/debounce"));
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const ShopInput_vue_1 = __importDefault(require("../Form/ShopInput.vue"));
const tyre_search_1 = require("./tyre-search");
const toastStore_1 = require("../../stores/toast/toastStore");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const productFilterStore_1 = require("../../stores/product/filter/productFilterStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'TagSearchInput',
    props: {
        placeholder: {
            type: String,
            default: "",
        },
        queryParams: {
            type: Object,
            default: () => {
                return {
                    type: 'carTyre',
                    nameAlias: '20555',
                };
            },
        },
        form: {
            type: Object,
            default: (0, vue_3.ref)(tyre_search_1.tyreSearchForm),
        },
        category: {
            type: String,
            default: 'carTyre',
        },
        width: {
            type: Array,
            default: () => []
        },
        profile: {
            type: Array,
            default: () => []
        },
        diameter: {
            type: Array,
            default: () => []
        },
        brandCode: {
            type: Array,
            default: () => []
        },
        treadCode: {
            type: Array,
            default: () => []
        },
        isPairSearchActive: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:width', 'update:profile', 'update:diameter', 'update:brandCode', 'update:treadCode', 'update:searchString'],
    setup(__props, { expose, emit }) {
        const props = __props;
        class TagSearchInputItem {
            constructor(label, filterValue) {
                this.label = label;
                this.filterValue = filterValue;
            }
        }
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const productFilterStore = (0, productFilterStore_1.useProductFilterStore)();
        const searchString = (0, vue_3.ref)("");
        const dropdownList = (0, vue_3.ref)([]);
        const cursor = (0, vue_3.ref)(-1);
        const filterValues = (0, vue_3.computed)(() => productFilterStore.productFilters);
        const tags = (0, vue_3.ref)([]);
        const isFocused = (0, vue_3.ref)(false);
        const tagSearchInputRef = (0, vue_3.ref)(null);
        const isProcessing = (0, vue_3.ref)(false);
        (0, vue_3.onMounted)(() => {
            document.addEventListener("click", handleClickOutside);
        });
        const filterByNameAlias = async (value, query) => {
            query.nameAlias = value;
            Object.keys(query).forEach(key => {
                if (key !== 'nameAlias' && key !== 'type' && key !== 'axCategory') {
                    delete query[key];
                }
            });
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'shop_products_get_filter_values_by_name_alias', query }).href);
                if (Array.isArray(response['hydra:member'])) {
                    const items = [];
                    response['hydra:member'].forEach(element => {
                        if (element['@type'] === 'ProductFilter') {
                            const tagValue = `${element.values.width}${element.values.profile.length ? '/' : ''}${element.values.profile} ${element.values.structure}${element.values.diameter}`;
                            // Csak akkor adjuk hozzá a dropdownhoz, ha a tagValue nem üres.
                            if (tagValue.trim() !== '') {
                                items.push(new TagSearchInputItem(tagValue, { id: 'nameAlias', value: element.values }));
                            }
                        }
                    });
                    items.sort((a, b) => a.label.localeCompare(b.label));
                    dropdownList.value.push(...items);
                    checkCursor();
                }
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const filterByBrand = (value, brandValues) => {
            const items = Object.keys(brandValues)
                .filter((key) => key.toLowerCase().includes(value.toLowerCase()) ||
                brandValues[key].toLowerCase().includes(value.toLowerCase()))
                .map((key) => new TagSearchInputItem(brandValues[key], { id: "brand", value: key }));
            items.sort((a, b) => a.label.localeCompare(b.label));
            return items;
        };
        const filterByTreadCode = (value, treadCodes) => {
            const items = treadCodes
                .filter((treadCode) => treadCode.toLowerCase().includes(value.toLowerCase()))
                .map((treadCode) => new TagSearchInputItem(treadCode, { id: 'treadCode', value: treadCode }));
            items.sort((a, b) => a.label.localeCompare(b.label));
            return items;
        };
        const checkCursor = () => {
            // check the cursor for possible invalid state
            if ((0 === dropdownList.value.length) && (-1 !== cursor.value)) {
                // nothing in the list, "unset" the cursor
                cursor.value = -1;
                return;
            }
            if (-1 === cursor.value) {
                // nothing selected, if we have dropdown values, we select the first
                if (dropdownList.value.length) {
                    cursor.value = 0;
                }
                return;
            }
            // we have items in the dropdown, and the cursor select something
            if (cursor.value >= dropdownList.value.length) {
                // the cursor is out of item, set to the first item
                cursor.value = 0;
            }
        };
        const moveCursor = (event) => {
            switch (event.key) {
                case 'ArrowDown':
                    cursor.value = Math.min(cursor.value + 1, Math.min(10, (dropdownList.value ? dropdownList.value.length : 0) - 1));
                    break;
                case 'ArrowUp':
                    cursor.value = Math.max(cursor.value - 1, -1);
                    break;
                case 'Enter':
                    if (cursor.value !== -1) {
                        itemSelected(dropdownList.value[cursor.value]);
                    }
                    break;
            }
        };
        const updateProperty = (propName, propValue, allowSplice = false) => {
            var _a;
            const currentValue = Array.isArray(props[propName]) ? [...props[propName]] : [];
            const shouldLimitToTwo = ['width', 'profile', 'diameter'].includes(propName);
            let updatedValue;
            // Tömb korlátozása maximum 2 elemre.
            if (shouldLimitToTwo) {
                const allKeys = ['width', 'profile', 'diameter'];
                const otherKeys = allKeys.filter(k => k !== propName);
                const anotherHasValue = otherKeys.some(key => { var _a; return ((_a = props[key]) === null || _a === void 0 ? void 0 : _a[0]) != null; });
                if (!props[propName] || props[propName] === null) {
                    // Ha ez a mező null és van másik mező, ami már kapott értéket -> [null, új].
                    if (anotherHasValue) {
                        updatedValue = [null, propValue];
                    }
                    else {
                        // Ha minden mező üres/null, akkor simán kezdjük el az új tömböt.
                        updatedValue = [propValue];
                    }
                }
                else {
                    // Ha a jelenlegi tömb hossza kisebb mint 2, hozzáadjuk az új értéket.
                    if (currentValue.length < 2) {
                        updatedValue = [...currentValue, propValue];
                    }
                    else {
                        // Felülíráskor törölnünk kell az előző nameAlias címkét, mert az már nem lesz érvényes címke.
                        if (allowSplice && tags.value.length > 0 && ((_a = tags.value[0].filterValue) === null || _a === void 0 ? void 0 : _a.id) === 'nameAlias') {
                            tags.value.splice(0, 1);
                        }
                        // Ha már 2 elem van, akkor első elem marad, a második helyére az új érték kerül.
                        updatedValue = [currentValue[0], propValue];
                    }
                }
            }
            else {
                // Ha nem kell korlátozni, egyszerűen hozzáadjuk az új értéket a tömbhöz.
                updatedValue = [...currentValue, propValue];
            }
            emit(`update:${propName}`, updatedValue);
        };
        const itemSelected = (item) => {
            isProcessing.value = true;
            searchString.value = '';
            dropdownList.value = [];
            cursor.value = -1;
            const sameTags = tags.value.filter(tag => tag.filterValue.id === item.filterValue.id);
            if (sameTags.some(tag => JSON.stringify(tag.filterValue.value) === JSON.stringify(item.filterValue.value))) {
                // ha ugyanez a tag mar hozza van adva, kilepunk
                isProcessing.value = false;
                return;
            }
            switch (item.filterValue.id) {
                case 'nameAlias':
                    // size tag hozzaadasa (1 vagy paros kereses eseten 2 adhato hozza)
                    if (2 == sameTags.length) {
                        // max ketto adhato hozza, kilepunk
                        isProcessing.value = false;
                        return;
                    }
                    if (1 == sameTags.length && !props.isPairSearchActive) {
                        // ha egy mar hozza van adva es nem paros kereses, kilepunk
                        isProcessing.value = false;
                        return;
                    }
                    // hozzaadhatjuk az uj tag-ot
                    tags.value.push(item);
                    if (typeof item.filterValue.value !== 'string') {
                        updateProperty('width', item.filterValue.value.width, true);
                        updateProperty('profile', item.filterValue.value.profile);
                        updateProperty('diameter', item.filterValue.value.diameter);
                    }
                    break;
                case 'brand':
                    // brand tag hozzaadasa (tobb is hozzaadhato)
                    // hozzaadhatjuk az uj tag-ot
                    tags.value.push(item);
                    updateProperty('brandCode', item.filterValue.value);
                    break;
                case 'treadCode':
                    // tread tag hozzaadasa (csak 1)
                    if (1 == sameTags.length) {
                        // ha egy mar hozza van adva, kilepunk
                        isProcessing.value = false;
                        return;
                    }
                    // hozzaadhatjuk az uj tag-ot
                    tags.value.push(item);
                    updateProperty('treadCode', item.filterValue.value);
                    break;
                default:
                    // invalid tag
                    isProcessing.value = false;
                    return;
            }
            // sorbarendezes, hogy ne keveredjenek a meretek a tobbivel
            tags.value = sortTags(tags.value);
            (0, vue_3.nextTick)(() => {
                isProcessing.value = false;
            });
        };
        const removeItem = (array, value) => {
            if (!array || !value) {
                return array || [];
            }
            const indexToRemove = array.indexOf(value);
            if (indexToRemove !== -1) {
                const updatedArray = [...array];
                updatedArray.splice(indexToRemove, 1);
                return updatedArray;
            }
            return array;
        };
        const removeLastNameAliasTag = () => {
            const nameAliasTags = tags.value.filter(tag => tag.filterValue.id === 'nameAlias');
            if (nameAliasTags.length > 1) {
                const lastNameAliasTag = nameAliasTags[nameAliasTags.length - 1];
                const indexToRemove = tags.value.indexOf(lastNameAliasTag);
                if (indexToRemove !== -1) {
                    tags.value.splice(indexToRemove, 1);
                    const { value } = lastNameAliasTag.filterValue;
                    if (typeof value !== 'string') {
                        emit('update:width', removeItem(props.width, value.width));
                        emit('update:profile', removeItem(props.profile, value.profile));
                        emit('update:diameter', removeItem(props.diameter, value.diameter));
                    }
                }
            }
            else {
                // Ha nem lenne nameAlias címke, akkor a többi értéket kell törölnünk.
                if (props.width && props.width.length > 1) {
                    emit('update:width', removeItem(props.width, props.width[1]));
                }
                if (props.profile && props.profile.length > 1) {
                    emit('update:profile', removeItem(props.profile, props.profile[1]));
                }
                if (props.diameter && props.diameter.length > 1) {
                    emit('update:diameter', removeItem(props.diameter, props.diameter[1]));
                }
            }
        };
        const sortTags = (tagsArray) => {
            const nameAliasTags = tagsArray.filter(tag => tag.filterValue.id === 'nameAlias');
            const brandTags = tagsArray.filter(tag => tag.filterValue.id === 'brand');
            const treadCodeTags = tagsArray.filter(tag => tag.filterValue.id === 'treadCode');
            // Mindig egymás után kerüljenek be a címkék, az alábbi sorrendben.
            return [...nameAliasTags, ...brandTags, ...treadCodeTags];
        };
        const deselectTag = (index) => {
            isProcessing.value = true;
            const deselected = tags.value.splice(index, 1).shift();
            if (!deselected)
                return;
            const { id, value } = deselected.filterValue;
            if (id === 'brand' && typeof value === 'string') {
                emit('update:brandCode', removeItem(props.brandCode, value));
            }
            else if (id === 'treadCode' && typeof value === 'string') {
                emit('update:treadCode', removeItem(props.treadCode, value));
            }
            else if (id === 'nameAlias' && typeof value !== 'string') {
                emit('update:width', removeItem(props.width, value.width));
                emit('update:profile', removeItem(props.profile, value.profile));
                emit('update:diameter', removeItem(props.diameter, value.diameter));
            }
            tags.value = sortTags(tags.value);
            (0, vue_3.nextTick)(() => {
                isProcessing.value = false;
            });
        };
        const resetTags = () => {
            isProcessing.value = true;
            if (searchString.value.trim() !== '') {
                return;
            }
            if (tags.value.length > 0) {
                const lastTag = tags.value.pop();
                if (lastTag) {
                    if (lastTag.filterValue.id === 'brand' && typeof lastTag.filterValue.value === 'string') {
                        emit('update:brandCode', removeItem(props.brandCode, lastTag.filterValue.value));
                    }
                    else if (lastTag.filterValue.id === 'treadCode' && typeof lastTag.filterValue.value === 'string') {
                        emit('update:treadCode', removeItem(props.treadCode, lastTag.filterValue.value));
                    }
                    else if (lastTag.filterValue.id === 'nameAlias' && typeof lastTag.filterValue.value !== 'string') {
                        emit('update:width', removeItem(props.width, lastTag.filterValue.value.width));
                        emit('update:profile', removeItem(props.profile, lastTag.filterValue.value.profile));
                        emit('update:diameter', removeItem(props.diameter, lastTag.filterValue.value.diameter));
                    }
                }
            }
            tags.value = sortTags(tags.value);
            (0, vue_3.nextTick)(() => {
                isProcessing.value = false;
            });
        };
        const handleClickOutside = (event) => {
            var _a;
            if (!((_a = tagSearchInputRef.value) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                isFocused.value = false;
            }
        };
        // Márka címkék frissítése a márkakód és márkanév alapján.
        const updateBrandTags = (newBrandCode, brandValues) => {
            if (!newBrandCode || !brandValues)
                return;
            tags.value = tags.value.filter(tag => tag.filterValue.id !== 'brand');
            newBrandCode.forEach((brandCode) => {
                const brandName = brandValues[brandCode] || brandCode;
                const brandTag = new TagSearchInputItem(brandName, { id: 'brand', value: brandCode });
                tags.value.push(brandTag);
            });
            tags.value = sortTags(tags.value);
        };
        // Futóminta címkék frissítése.
        const updateTreadCodeTags = (newTreadCodes) => {
            if (!newTreadCodes)
                return;
            tags.value = tags.value.filter(tag => tag.filterValue.id !== 'treadCode');
            newTreadCodes.forEach((treadCode) => {
                const treadTag = new TagSearchInputItem(treadCode, { id: 'treadCode', value: treadCode });
                tags.value.push(treadTag);
            });
            tags.value = sortTags(tags.value);
        };
        // NameAlias címkék frissítése a szélesség, profil és átmérő alapján.
        const updateNameAliasTags = async (newWidths, newProfiles, newDiameters) => {
            tags.value = tags.value.filter(tag => tag.filterValue.id !== 'nameAlias');
            if (!newWidths || !newDiameters)
                return;
            const updatedTags = [...tags.value];
            // Végigiterálunk az szélességeken és minden egyes szélességhez, profilhoz és átmérőhöz hozzárendeljük az új címkéket.
            for (let i = 0; i < newWidths.length; i++) {
                const width = newWidths[i];
                const profile = (newProfiles === null || newProfiles === void 0 ? void 0 : newProfiles[i]) || '';
                const diameter = newDiameters[i];
                // Ha nincs width vagy diameter, akkor átugorjuk ezt a lépést (profil lehet üres).
                if (!width || !diameter) {
                    continue;
                }
                // A keresett 'nameAlias' érték összeállítása a szélességből, profilból és átmérőből, pl.: 2055516.
                const nameAliasQuery = `${width}${profile}${diameter}`.replace(/\D/g, '');
                // A már létező 'nameAlias' címkék közötti címke keresése és az aktuális címke értékének lekérése index alapján.
                const existingNameAliasTags = updatedTags.filter(tag => tag.filterValue.id === 'nameAlias');
                const tagToReplace = existingNameAliasTags[i];
                const currentTag = tagToReplace === null || tagToReplace === void 0 ? void 0 : tagToReplace.filterValue.value;
                // Ellenőrizzük, hogy az aktuális címke értéke változott-e a korábbihoz képest.
                const hasChanged = currentTag && typeof currentTag === 'object' && (currentTag.width !== width ||
                    currentTag.profile !== profile ||
                    currentTag.diameter !== diameter);
                // Ha változás történt, vagy ha nincs jelenleg érték, frissítjük a címkét.
                if (hasChanged || !currentTag) {
                    try {
                        // Kérés küldése a nameAlias alapján.
                        const response = await (0, fetch_1.default)(router.resolve({
                            name: 'shop_products_get_filter_values_by_name_alias',
                            query: { nameAlias: nameAliasQuery }
                        }).href);
                        const members = response['hydra:member'];
                        const nameAliasTagIndex = updatedTags.findIndex(tag => tag === tagToReplace);
                        // Ha van találat, új címkét hozunk létre, vagy a jelenlegit frissítjük.
                        if (Array.isArray(members) && members.length > 0) {
                            const firstMember = members[0];
                            if (firstMember['@type'] === 'ProductFilter') {
                                const newTag = new TagSearchInputItem(`${firstMember.values.width}${firstMember.values.profile.length ? '/' : ''}${firstMember.values.profile} ${firstMember.values.structure}${firstMember.values.diameter}`, { id: 'nameAlias', value: firstMember.values });
                                // Jelenlegi címke frissítése vagy új címke hozzáadása.
                                if (nameAliasTagIndex !== -1) {
                                    updatedTags.splice(nameAliasTagIndex, 1, newTag);
                                }
                                else {
                                    updatedTags.push(newTag);
                                }
                            }
                        }
                        else {
                            // Ha nincs találat, eltávolítjuk a címkét.
                            if (nameAliasTagIndex !== -1) {
                                updatedTags.splice(nameAliasTagIndex, 1);
                            }
                        }
                    }
                    catch (error) {
                        toastStore.addErrorToast(error.toString());
                    }
                }
            }
            tags.value = sortTags(updatedTags);
        };
        // Méret, márka, futóminta keresése és szűrése.
        (0, vue_3.watch)(searchString, (0, debounce_1.default)((value) => {
            var _a, _b;
            dropdownList.value = [];
            if (!searchString.value.length) {
                return;
            }
            const query = Object.fromEntries(Object.entries(props.form).filter(([prop, value]) => {
                if (typeof value === 'boolean') {
                    return value;
                }
                return value !== null;
            }));
            if (typeof query['axCategories'] !== 'undefined') {
                query.axCategory = query['axCategories'];
                delete query['axCategories'];
            }
            // Méret szűrés.
            const isSizeQuery = !isNaN(value.substr(0, 1));
            if (isSizeQuery) {
                filterByNameAlias(value, query);
            }
            // Márka szűrés.
            const brandValues = (_a = filterValues.value) === null || _a === void 0 ? void 0 : _a.brands.values;
            if (typeof brandValues === "object" && !Array.isArray(brandValues)) {
                dropdownList.value = filterByBrand(value, brandValues);
            }
            // Futóminta szűrés.
            if (dropdownList.value.length === 0) {
                dropdownList.value = filterByTreadCode(value, (_b = filterValues.value) === null || _b === void 0 ? void 0 : _b.treadCodes.values);
            }
            checkCursor();
        }, 500));
        // Márka, futóminta, szélesség, profil, átmérő változásakor a megfelelő címkék frissítése.
        (0, vue_3.watch)(() => [props.brandCode, props.treadCode, props.width, props.profile, props.diameter], async ([newBrandCode, newTreadCode, newWidth, newProfile, newDiameter]) => {
            var _a, _b;
            if (isProcessing.value)
                return;
            const brandValues = (_b = (_a = filterValues.value) === null || _a === void 0 ? void 0 : _a.brands) === null || _b === void 0 ? void 0 : _b.values;
            if (brandValues) {
                updateBrandTags(newBrandCode, brandValues);
            }
            updateTreadCodeTags(newTreadCode);
            await updateNameAliasTags(Array.isArray(newWidth) ? newWidth : null, Array.isArray(newProfile) ? newProfile : null, Array.isArray(newDiameter) ? newDiameter : null);
        }, { immediate: true, deep: true });
        (0, vue_3.watch)(searchString, (newValue) => {
            emit('update:searchString', newValue);
        });
        (0, vue_3.watch)(() => props.isPairSearchActive, (isActive) => {
            if (!isActive) {
                removeLastNameAliasTag();
            }
        });
        (0, vue_3.onUnmounted)(() => {
            document.removeEventListener("click", handleClickOutside);
        });
        expose({ resetTags });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                ref_key: "tagSearchInputRef",
                ref: tagSearchInputRef,
                class: "tag-search-input"
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    _hoisted_2,
                    (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                        modelValue: searchString.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchString).value = $event)),
                        type: "text",
                        placeholder: __props.placeholder,
                        class: "h-full",
                        "disable-focus-ring": "",
                        onKeyup: moveCursor,
                        onFocusin: _cache[1] || (_cache[1] = ($event) => (isFocused.value = true))
                    }, null, 8, ["modelValue", "placeholder"])
                ]),
                (tags.value.length > 0 && isFocused.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("ul", _hoisted_3, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(tags.value, (tag, index) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                                key: tag.filterValue.id,
                                onClick: ($event) => (deselectTag(index))
                            }, [
                                (0, vue_2.createElementVNode)("span", _hoisted_5, (0, vue_2.toDisplayString)(tag.label), 1),
                                _hoisted_6
                            ], 8, _hoisted_4));
                        }), 128))
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (dropdownList.value.length)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("ul", _hoisted_7, [
                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(10, (i) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: i }, [
                                (dropdownList.value[i - 1])
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                                        key: 0,
                                        class: (0, vue_2.normalizeClass)({ 'bg-gray': cursor.value === i - 1 }),
                                        onClick: ($event) => (itemSelected(dropdownList.value[i - 1]))
                                    }, (0, vue_2.toDisplayString)(dropdownList.value[i - 1].label), 11, _hoisted_8))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ], 64));
                        }), 64)),
                        (dropdownList.value.length > 10)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_9, " ... "))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 512));
        };
    }
});
